import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import banksList from '@/app/shared/domain/data/banks';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputBank',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {




return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    "model-value": __props.modelValue,
    label: "Banco",
    items: _unref(banksList),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:modelValue', value))
  }, null, 8, ["model-value", "items"]))
}
}

})